import { render, staticRenderFns } from "./historicalData.vue?vue&type=template&id=6aa2cedf&scoped=true&"
import script from "./historicalData.vue?vue&type=script&lang=js&"
export * from "./historicalData.vue?vue&type=script&lang=js&"
import style0 from "./historicalData.vue?vue&type=style&index=0&id=6aa2cedf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa2cedf",
  null
  
)

export default component.exports